<template>
    <b-modal v-model="show" title="РЕГРЕССИЯ БИНО ПАРАМЕТРЛАРИ">
        <div class="container-fluid">
            <div class="row">
                <div class="col">
                    <div class="form-group">
                        <label>Код<span class="red">*</span></label>
                        <input
                                type="text"
                                class="form-control"
                                v-model="data.code"
                                :class="{'is-invalid': $v.data.code.$error}"
                                @blur="$v.data.code.$touch()"
                        />
                        <div class="invalid-feedback" v-if="$v.data.code.$error">{{$t("realEstate.validation.cadastreBuildingFieldEdit.code")}}</div>
                    </div>
                    <div class="form-group">
                        <label>Текст<span class="red">*</span></label>
                        <input
                                type="text"
                                class="form-control"
                                v-model="data.name"
                                :class="{'is-invalid': $v.data.name.$error}"
                                @blur="$v.data.name.$touch()"
                        />
                        <div class="invalid-feedback" v-if="$v.data.name.$error">{{$t("realEstate.validation.cadastreBuildingFieldEdit.nameUz")}}</div>
                    </div>
                    <div class="form-group">
                        <label>Текст(ru)<span class="red">*</span></label>
                        <input
                                type="text"
                                class="form-control"
                                v-model="data.nameRu"
                                :class="{'is-invalid': $v.data.nameRu.$error}"
                                @blur="$v.data.nameRu.$touch()"
                        />
                        <div class="invalid-feedback" v-if="$v.data.nameRu.$error">{{$t("realEstate.validation.cadastreBuildingFieldEdit.nameRu")}}</div>
                    </div>
                    <div class="form-group">
                        <label>Тури<span class="red">*</span></label>
                        <select class="form-control" v-model="data.type">
                            <option :value="type.text" v-for="type in types" :key="type.value">{{type.value}}</option>
                        </select>
                    </div>
                    <div class="form-group" v-if="data.type === 'LISTBOX' || data.type === 'COMBOBOX' || data.type === 'MULTISELECT'">
                        <label>Референс<span class="red">*</span></label>
                        <v-select
                                v-model="data.reference"
                                label="name"
                                :options="references"
                                :filterable="false"
                                @search="onReferenceSearch"
                                @search:focus="onReferenceFocus">
                            <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                        >
                        </v-select>
                    </div>
                    <div class="form-group">
                        <label>Бино категорияси<span class="red">*</span></label>
                        <select class="form-control" v-model="data.buildingCategory">
                            <option value="Notorious">НОТУРАР</option>
                            <option value="Residential">ТУРАР</option>
                        </select>
                    </div>
                    <div class="form-check">
                        <label class="form-check-label pl-0">
                            <input type="checkbox" class="form-check-input" v-model="data.required">
                            <span class="form-check-sign"></span>
                            Мажбурий
                        </label>
                    </div>
                </div>
            </div>
        </div>
        <div slot="modal-footer" class="w-100 pt-3">
            <button class="all-btn add-btn float-right" v-if="hasPermission('SETTINGS_CAD_BUILDING_FIELD_REGRESSION_ADD')" @click="save">Сақлаш</button>
            <button class="all-btn delete-btn float-right mr-2" @click="show = false">Бекор қилиш</button>
        </div>
    </b-modal>
</template>

<script>
    import bModal from 'bootstrap-vue/es/components/modal/modal'
    import bModalDirective from 'bootstrap-vue/es/directives/modal/modal'
    import {clone} from '@/shared/utils';
    import { required } from 'vuelidate/lib/validators';
    import initFilterModel from '@/shared/filter';

    export default {
        components: {
            'b-modal': bModal,
        },
        directives: {
            'b-modal': bModalDirective
        },
        data() {
            return {
                show: false,
                processing: false,
                loading: false,
                referenceFilter: initFilterModel(),
                data: {
                    code: '',
                    name: '',
                    nameRu: '',
                    required: true,
                    type: 'TEXT',
                    buildingCategory: 'Notorious',
                    reference: null
                },
                references: [],
                types: [
                    { text: 'TEXT', value: 'TEXT',disabled: true},
                    { text: 'INTEGER', value: 'INTEGER', disabled: true},
                    { text: 'DECIMAL', value: 'DECIMAL', disabled: true},
                    { text: 'LISTBOX', value: 'LISTBOX', disabled: true},
                    { text: 'COMBOBOX', value: 'COMBOBOX', disabled: true},
                    { text: 'MULTISELECT', value: 'MULTISELECT', disabled: true},
                    { text: 'DATE_PICKER', value: 'DATE_PICKER', disabled: true},
                ]
            }
        },
        validations: {
            data: {
                code: {
                    required: required
                },
                name: {
                    required: required
                },
                nameRu: {
                    required: required
                }
            }
        },
        methods: {
            initData() {

            },
            save() {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }
                this.processing = true;
                this.$http.post('/building/field',this.data)
                    .then(res =>{
                        this.processing = false;
                        const response = res.data;
                        if (response.status === 'SUCCESS') {
                            this.show = false
                            this.$eventBus.$emit('buildingFieldChanged', response)
                        }
                    }, err => {
                        this.processing = false;
                        console.log(err)
                    })

            },
            onReferenceSearch(searchTxt, loading) {
                this.references = [];
                this.referenceFilter.search = searchTxt;
                this.$http.post('/building/field/reference/list', this.referenceFilter)
                    .then(res => {
                        this.references = res.data.data;
                        console.log(res.data);
                        loading(false)
                    }, err => {
                        console.log(err)
                    })
            },
            onReferenceFocus() {
                this.references = [];
                this.referenceFilter.search = '';
                this.$http.post('/building/field/reference/list', this.referenceFilter)
                    .then(res => {
                        this.references = res.data.data;
                        console.log(res.data);
                    }, err => {
                        console.log(err)
                    })
            }
        },
        created() {
            this.initData();
            this.referenceFilter.parentOnly = true;
            this.referenceFilter.page.size = 1000;
            this.$eventBus.$on("showBuildingFieldAddModal", (data) => {
                if (data) {
                    this.data = clone(data)
                } else  {
                    this.data = {}
                }
                this.show = true
            })
        }
    }
</script>

<style scoped>

</style>